import InfiniteCarousel from 'components/infinite/InfiniteCarousel';
import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
export default class HomeLinks extends Component {
    getModulesMap() {
        return {
            infiniteCarousel: ['.home-links__list', InfiniteCarousel]
        };
    }
    bindEvents(add) {
        const method = bindMethod(add);
        this.modules.infiniteCarousel.modules.infiniteLine.items.forEach((link) => {
            link[method]('mouseover', (e) => {
                this.modules.infiniteCarousel.enabled = false;
                this.onItemOver(e);
            });
            link[method]('mouseleave', (e) => {
                this.modules.infiniteCarousel.enabled = true;
                this.onItemOut();
            });
        });
    }
    onItemOver = (e) => {
        this.modules.infiniteCarousel.modules.infiniteLine.items.forEach((link) => {
            link.classList.remove('active');
            link.classList.add('inactive');
        });
        const link = e.currentTarget;
        link.classList.remove('inactive');
        link.classList.add('active');
    };
    onItemOut = () => {
        this.modules.infiniteCarousel.modules.infiniteLine.items.forEach((link) => {
            link.classList.remove('active');
            link.classList.remove('inactive');
        });
    };
}
